export type FundingLandingDiagnosticAdditionalFields = {
  hasRaisedFunding?: boolean | null
  priorFundingAmountLabel?: string | null
  productStage?: string | null
  hasRevenue?: boolean | null
  revenueAmountLabel?: string | null
}

export const FUNDING_LANDING_DIAGNOSTIC_STEPS = [
  'start',
  'startup',
  'traction',
  'analyzing',
  'results',
  'register',
] as const

export type FundingLandingDiagnosticStep = (typeof FUNDING_LANDING_DIAGNOSTIC_STEPS)[number]

export const PRODUCT_STAGES = ['Idea', 'Prototype', 'Launched', 'Selling'] as const

export const RAISE_PRESETS = [
  { label: '$250k', value: 250_000 },
  { label: '$500k', value: 500_000 },
  { label: '$1M', value: 1_000_000 },
  { label: '$3M', value: 3_000_000 },
  { label: '$5M+', value: 5_000_000 },
] as const

export const INDUSTRY_CHIP_OPTIONS = [
  { label: 'HealthTech', tagTitle: 'HealthTech' },
  { label: 'SaaS', tagTitle: 'SaaS' },
  { label: 'FinTech', tagTitle: 'FinTech' },
  { label: 'AI / ML', tagTitle: 'Artificial Intelligence (AI)' },
] as const

export type IndustryChipOption = (typeof INDUSTRY_CHIP_OPTIONS)[number]

export const isIndustryChipActive = (chip: IndustryChipOption, selectedTitles: string[]) =>
  selectedTitles.includes(chip.tagTitle)
